import { getIdentifiedPlatformConfig } from '@hmhco/login-config';

export const redirectToAiToolsLogin = (timeout = 3000) => {
  const { aiToolsStartUrl } = getIdentifiedPlatformConfig();

  setTimeout(() => {
    if (aiToolsStartUrl) {
      window.location.href = aiToolsStartUrl;
    } else {
      window.location.href = `${window.location.origin}/ui/login`;
    }
  }, [timeout]);
};

export default redirectToAiToolsLogin;
